import React from 'react';
import { useTranslation } from 'react-i18next';
import Error from '../../components/Error';
import Container from '../../layout/container';

export default function NotFound404() {
  const { t } = useTranslation();

  return (
    <Container>
      <Error message={t('page_not_found')} />
    </Container>
  );
}
